<template>
  <div class="permissions__manager__component">
    <b-modal size="sm" hide-footer id="editRoleModal" title="Edit role title" class="modal-edit-role">
        <EditRoleModal :roleData="role" ref="refEditModal"/>
    </b-modal>
    <b-modal
      type="warn"
      title="Confirm Delete"
      id="confirmDeleteRole"
      @ok="removeRole"
      ok-title="Yes, Remove"
    >
      <p>Are you sure you want to remove this role?</p>
    </b-modal>
    <HeaderControls  :namespace="namespace"/>
    <div class="fixed-top-bar-padding">
        <div class="container-fluid">
            <h2 class="permission-title-manager">
                <span class="title-icon">
                    <i class="fas fa-user-lock"></i>
                </span>
                Permission Manager
            </h2>
        </div>

        <div class="container-fluid">
            <div class="role-permissions row no-gutters">
                <div class="roles col-sm-12 col-md-3">
                    <div class="form-group">
                        <label>Roles</label>
                        <multiselect
                            ref="role"
                            v-model="role"
                            track-by="id"
                            label="name"
                            open-direction="bottom"
                            :options="allRoles"
                            :show-labels="false"
                            :multiple="false"
                            :allowEmpty="false"
                            :taggable="true"
                            :close-on-select="true"
                            :hide-selected="false"
                            :preserve-search="true"
                            :clear-on-select="true"
                            tagPlaceholder="Press enter to create a role"
                            @input="getRolePermissions"
                            @tag="createRoles"
                        >
                        </multiselect>
                        <div v-if="userAbilities.roleManager" class="role-btns text-primary" v-show="showRoleBtns">
                            <span @click="showEditRoleModal" v-b-tooltip.hover title="Edit role" class="cursor-pointer">
                                <i class="fas fa-edit"></i>
                            </span>
                            <span v-if="showDeleteRole" @click="$bvModal.show('confirmDeleteRole')" v-b-tooltip.hover title="Delete role" class="cursor-pointer">
                                <i class="fas fa-trash"></i>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="permissions col-sm-12 col-md-9">
                    <label>Permissions</label>
                    <div class="permission-checkbox-groups-container">
                        <b-form-checkbox-group
                            :id="`permission-checkbox-group-${i}`"
                            class="permission-group"
                            v-model="ability"
                            name="permission"
                            :disabled="!userAbilities.roleManager"
                            v-for="i in getMaxGroupNumber()" :key="i"
                        >
                            <!-- <div v-for="i in getMaxGroupNumber()" :key="i"> -->
                                <b-form-checkbox v-for="j in allAbilities.filter(x => x.group_number == i)" :key="j.id" :value="j.value" class="permission-entry">{{j.text}}</b-form-checkbox>
                            <!-- </div> -->
                        </b-form-checkbox-group>
                    </div>
                </div>
                <div class="preferences col-sm-12 col-md-3"></div>
                <div class="preferences col-sm-12 col-md-9">
                    <label>Default Preferences</label>
                    <div class="preferences-deliverable-type-container">
                        <multiselect
                            ref="roleDefaultDeliverableType"
                            :show-labels="false"
                            :multiple="true"
                            :options="preferenceDeliverableTypes"
                            v-model="preferenceData"
                            label="name"
                            track-by="id"
							:close-on-select="false"
                        >
                        </multiselect>
                    </div>
                </div>
                <div v-if="userAbilities.roleManager" class="col-12 mt-2">
                    <b-button @click="saveRolePermissions" class="header-filter-btns" variant="theme">
                        Save
                        <i class="fas text-primary fa-save fa-fw float-right"></i>
                    </b-button>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import toast from "../toast";
import HeaderControls from "../components/common/HeaderControls";
import EditRoleModal from "../components/common/EditRoleModal";
import { mapGetters, mapActions } from 'vuex';
export default {
    data() {
        return {
        	namespace:"",
            role: '',
            ability: [],
            showRoleBtns: false,
            showDeleteRole: false,
            preferenceData: null,
        }
    },
    components: {
        HeaderControls,
        EditRoleModal
    },
    mounted() {
        this.fetchAllRoles();
        this.fetchAllAbilities().then(r => {
            console.log(this.allAbilities);
        });
    },
    methods: {
        ...mapActions([
            'fetchAllRoles',
            'fetchAllAbilities',
            'fetchRolePreference'
        ]),
        showEditRoleModal() {
            this.$bvModal.show('editRoleModal');
        },
        removeRole() {
            let that = this;
            this.$store.dispatch("removeRole", this.role).then(function(resp) {
                if(resp != false) {
                    that.showRoleBtns = false;
                    that.ability = [];
                    that.role = '';
                }
            });
        },
        createRoles(newRole) {
            let that = this;
            this.$store.dispatch("createRole", {newRole}).then(function(resp) {
                that.ability = [];
                that.role = resp;
                that.showDeleteRole = true;
                that.showRoleBtns = true;
            });
        },
        saveRolePermissions() {
            if(typeof this.role.id == 'undefined') {
                toast.info('Please select a role first to change its permissions.');
                return;
            }
            toast.info('Saving permissions...');
            let rolePermissionData = {
                roleId: this.role.id,
                ability: this.ability,
                preference: this.preferenceData,
            }
            this.$store.dispatch('saveRolePermissions', rolePermissionData).then(function() {
                toast.hide();
            }).catch(function() {
                toast.hide();
            });
        },
        getRolePermissions() {
            let that = this;
            this.showRoleBtns = true;
            this.$store.dispatch('fetchRolePermissions', {roleId: this.role.id}).then(function(resp) {
                that.ability = resp.rolePermissions;
                that.showDeleteRole = resp.roleUsed;
                that.preferenceData = resp.preference;
            });
        },

        getMaxGroupNumber() {
            let max = 0;
            for (let x of this.allAbilities) {
                if (x.group_number > max) max = x.group_number;
            }

            return max;
        },
    },
    computed: {
        ...mapGetters([
            'allRoles',
            'allAbilities',
            'userAbilities',
            'preferenceDeliverableTypes'
        ])
    }
};
</script>

<style>
</style>